import Footer from 'csdd_components/Footer';
import HomeNavBar from 'csdd_components/HomeNavBar';
import Newsletter from 'csdd_components/Newsletter';
import Partners from 'csdd_components/Partners';
import TopNavBar from 'csdd_components/TopNavBar';

const OurPartners = () => {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <Partners />
      <Newsletter />
      <Footer />
    </>
  );
};
export default OurPartners;
